import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'title'
    }
  },
  {
    path: '/base',
    name: 'BaseKnow',
    meta: {
      title: 'baseTitle'
    },
    component: () => import('../views/BaseKnow')
  },
  {
    path: '/safe',
    name: 'SafeKnow',
    meta: {
      title: 'safeTitle'
    },
    component: () => import('../views/SafeKnow')
  },
  {
    path: '/DeFi',
    name: 'DeFi',
    meta: {
      title: 'DeFiTitle'
    },
    component: () => import('../views/DeFi')
  },
  {
    path: '/normal',
    name: 'Normal',
    meta: {
      title: 'normalTitle'
    },
    component: () => import('../views/Normal')
  },
  {
    path: '/token',
    name: 'TokenManage',
    meta: {
      title: 'tokenTitle'
    },
    component: () => import('../views/TokenManage')
  },
  {
    path: '/wallet',
    name: 'WalletManage',
    meta: {
      title: 'walletTitle'
    },
    component: () => import('../views/WalletManage')
  },
  {
    path: '/transfer',
    name: 'Transfer',
    meta: {
      title: 'transferTitle'
    },
    component: () => import('../views/Transfer')
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
